import { render, staticRenderFns } from "./UploadPurchaseModal.vue?vue&type=template&id=fd5fd0bc&scoped=true"
import script from "./UploadPurchaseModal.vue?vue&type=script&lang=ts"
export * from "./UploadPurchaseModal.vue?vue&type=script&lang=ts"
import style0 from "./UploadPurchaseModal.vue?vue&type=style&index=0&id=fd5fd0bc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5fd0bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd5fd0bc')) {
      api.createRecord('fd5fd0bc', component.options)
    } else {
      api.reload('fd5fd0bc', component.options)
    }
    module.hot.accept("./UploadPurchaseModal.vue?vue&type=template&id=fd5fd0bc&scoped=true", function () {
      api.rerender('fd5fd0bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/UploadPurchaseModal.vue"
export default component.exports